import type { QueryKey } from '@tanstack/react-query';

export const getBaseDependencyFetchQueryKey = (dependencyRevisionLocator: string): QueryKey => [
  'fetch',
  'dependencies',
  'dependencies',
  dependencyRevisionLocator,
];
